import React, { memo, ReactElement } from "react";
import { InitalLoadingScreenV4 } from "./v4";

interface InitalLoadingScreenProps {
    className?: string;
}

function InitalLoadingScreen(props: InitalLoadingScreenProps): ReactElement {
    return <InitalLoadingScreenV4 {...props} />;
}

export default memo(InitalLoadingScreen);
